import Layout from '@components/layout/Main'
import PostsAll from '@components/blog/pages/PostsAll'
import Seo from 'src/seo/components/Seo'
import JsonLdBlogArticleList from 'src/seo/jsonld/JsonLdBlogArticleList'
// import Article from '@components/html/Article'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'
import ConnectedAdsSections from '@components/blog/components/post/ConnectedAdsSections'

import { SLUG_TO_DOCTYPE, SLUG_TO_NAME, DOC_TYPE_INFO } from '@constants/articles/docTypes'

import dbConnect from 'db/dbConnect'
import blogRepo from 'db/repo/blog'
// import useUrlSeo from 'src/seo/server/useUrlSeo'
// import usePageSeo from 'src/seo/server/usePageSeo'
import usePageSeoWithArticles, { articlesQuery } from 'src/seo/server/usePageSeoWithArticles'
import splitOffersViaAdType from '@utils/offers/splitOffersViaAdType'

const PER_PAGE = 10
export default function BlogMainPage ({
    articles,
    connectedAds,
    pagination,
    query,
    seo,
    sidebar,
}) {

    const category = query.kategoria
    const docType = SLUG_TO_DOCTYPE[category]
    const docName = SLUG_TO_NAME[category || 'null']
    const docMeta = DOC_TYPE_INFO[docType]
    const backLink = docMeta ? docMeta.backLink : ['/', 'Darmowe ogłoszenia']
    const [backLinkHref, backLinkName] = backLink || []

    const firstPage = !query.strona || query.strona === '1'

    const additionalContent = connectedAds && <div className="container">
        <ConnectedAdsSections connectedAds={connectedAds} />
    </div>

    return (
        <Layout footerArticle={firstPage && seo.articleFile}>
            <Seo seo={seo} />
            <JsonLdBlogArticleList articles={articles} title={docName} />
            <PostsAll
                additionalContent={additionalContent}
                data={articles}
                initialParams={{...query,category:docType}}
                pagination={pagination}
                sidebar={sidebar}
                seo={seo} />

            {/* <div className="container">
                <Article article={seo.articleFile} />
                <br/><br/>
            </div> */}

            { backLink && <FrontpageLinks sections={[
                ['Powrót', [backLinkName], [backLinkHref]]
            ]} /> }
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = context.query
    const { articles, pagination } =
        await blogRepo.getArticles(query, PER_PAGE)

    const sidebar = await blogRepo.getSidebarData()
    const connectedAds = splitOffersViaAdType(await blogRepo.getConnectedAdsForMainBlogPages())

    // TODO: cache
    return {
        props: {
            connectedAds,
            articles,
            pagination,
            query,
            seo: query.tagi
                ? await usePageSeo({
                    pageId: 'blog-tagi',
                    substituteQuery: articlesQuery(query, articles),
                    query,
                  })

                //   await useUrlSeo({
                //     baseUrl: '/informacje-motoryzacja/tagi',
                //     resolvedUrl: context.resolvedUrl,
                //     substituteQuery: articlesQuery(query, articles),
                //     query,
                //   })

                : await usePageSeoWithArticles({ query, articles }),

            sidebar,
        }
    }
}